import { Link } from 'react-router-dom';
import { BowArc } from '@/components/ui/BowArc';
import { Eyebrow } from '@/components/ui/Typography';

// Trilho de arco vertical (180°) — assinatura da marca na borda esquerda.
const ARC_RAIL =
  'linear-gradient(180deg,#EE263E,#DE7C00,#FFB92A,#00C072,#0090E2,#835DD0,#8345BA)';

interface Props {
  /** kWh da sessão recém-concluída — âncora do convite. */
  energyKwh: number;
}

/**
 * Convite à Aliança no pós-carga (Receipt) — variante "enxuta · uma linha".
 *
 * Ancora no kWh REAL da sessão (a "moeda" do programa), no momento de maior
 * intenção. Renderizado entre o Card de Total e os botões de ação, SÓ para
 * não-membros (gate no caller, via `me.adesao_disponivel`). O card de NPS é um
 * overlay fixo separado — não conflita com este card inline.
 *
 * Fonte do design: bundle Claude Design app-bow-recarga/project/alianca-receipt-card.jsx
 * (AliancaReceiptCardEnxuta), escolhida pelo Saulo.
 */
export function AliancaReceiptCard({ energyKwh }: Props) {
  const kwh = energyKwh.toFixed(1).replace('.', ',');
  return (
    <Link
      to="/alianca"
      className="relative flex items-center gap-3.5 overflow-hidden rounded-[22px] bg-white px-4 py-3.5"
      style={{ boxShadow: '0 1px 2px rgba(0,27,116,0.04), 0 6px 16px rgba(0,27,116,0.06)' }}
    >
      <span aria-hidden className="absolute inset-y-0 left-0 w-[5px]" style={{ background: ARC_RAIL }} />
      <span className="shrink-0 pl-1">
        <BowArc size={38} variant="gradient" spin />
      </span>
      <div className="min-w-0 flex-1">
        <Eyebrow>A Aliança</Eyebrow>
        <div
          className="mt-0.5 leading-[1.22] text-bow-royal"
          style={{
            fontFamily: 'Chillax, system-ui, sans-serif',
            fontWeight: 500,
            fontSize: 16,
            letterSpacing: '-0.02em'
          }}
        >
          Esses <span style={{ color: '#00A664' }}>{kwh} kWh</span> já contariam pro seu nível
        </div>
      </div>
      <span className="inline-flex h-[38px] shrink-0 items-center gap-1.5 rounded-full bg-bow-royal px-4 text-[13.5px] font-semibold text-bow-cream">
        Aderir
        <ArrowIcon />
      </span>
    </Link>
  );
}

function ArrowIcon() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M5 12h14M13 5l7 7-7 7" />
    </svg>
  );
}
